<template>
    <div id="app">
        <router-view v-if="$store.state.db"></router-view>
    </div>
</template>

<script>
    import {
        GetBaseInfo,
    } from "./components/Request"
    import {
        connect,
        subscribeByNodes,
        unsubscribeByNodes
    } from "./mqtt/index"

    export default {
        name: "App",
        data() {
            return {}
        },
        async created() {
            await GetBaseInfo({
                projectId: this.$store.state.projectId
            }).then(({
                data
            }) => {
                this.influxDbName = data.data.project.influxDbName
                let gisUrl = data.data.project.webgisUrl.split('/')
                let len = gisUrl.length

                this.$store.commit("set_val", {
                    gisUrl: gisUrl[len - 1],
                    db: this.influxDbName
                });
            }).then(() => {
                connect()
                subscribeByNodes(["Ua", "Ub", "Uc", "Ia", "Ib", "Ic", "PA", "PR", "P", "PF","PFa","PFb","PFc", "U_unbl",
                    "I_unbl", "SwitchOn","Temperature_A","Temperature_B","Temperature_C", 'Monthly_Power_Generation', 'Daily_Power_Generation'
                ])
            })
            // await connect()
        },
        async mounted() {
            let html = document.getElementsByTagName("html")[0];
            this.reset(html)
            window.onresize = () => {
                this.reset(html)
            }
        },
        methods: {
            reset(html) {
                html.style.fontSize = window.innerWidth * window.innerHeight / 1920 / 1080 + 'px'
            },
            
        },
    };
</script>

<style lang="less">
    @import "./assets/fonts/font.css";
    @import "./assets/css/global";
    @import "./assets/css/func";
</style>